import { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button, IconButton, Tab, Tabs, Typography } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import Select from "react-select";
import { Row, Col } from "react-bootstrap";
import SucessModal from "../successModal/SuccessModal.js";
import { toast } from "sonner";
import { confirmDelete, showSuccessAlert } from "../../Swal.js";
import { getDropDownVal } from "../dropdownUtils.js";
import CustomLoader from "../static/CustomLoader.js";

const NAVY = "#123B5D";
const BLUE = "#3F8FE8";
const BORDER = "#DCE4EC";
const MUTED = "#5B6B7A";

const tabStyles = {
  minHeight: 46,
  borderBottom: "1px solid #E3E8ED",
  "& .MuiTabs-flexContainer": {
    gap: 0.5,
  },
  "& .MuiTab-root": {
    minHeight: 46,
    px: 2.5,
    py: 0,
    color: "#6B7785",
    fontSize: 14,
    fontWeight: 600,
    textTransform: "none",
    borderRadius: "8px 8px 0 0",
  },
  "& .MuiTab-root:hover": {
    color: NAVY,
    backgroundColor: "#F5F8FB",
  },
  "& .Mui-selected": {
    color: `${NAVY} !important`,
    fontWeight: 700,
  },
  "& .MuiTabs-indicator": {
    height: 3,
    borderRadius: "3px 3px 0 0",
    backgroundColor: NAVY,
  },
};

const SampEmp = ({ selectedId, mode, onHide, setRefresh }) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const [errors, setErrors] = useState({});
  const [pincodeError, setPincodeError] = useState("");
  const [supervisorOptions, setSupervisorOptions] = useState([{}]);
  const [divisionData, setDivisionData] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [ctypeOptions, setCtypeOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingc, setLoadingc] = useState(false);
  const [newItem, setNewItem] = useState({
    id: "",
    code: "",
    name: "",
    lastname: "",
    gender: "",
    empid: "",
    supervisor: "",
    department: "",
    designation: "",
  });
  const [empcontact, setEmpcontact] = useState([]);
  const [newodtItem, setNewodtItem] = useState({
    id: "",
    addressline1: "",
    addressline2: "",
    pincode: "",
    city: "",
    dist: "",
    state: "",
    country: "",
    primaryphone: "",
    secondaryphone: "",
    emailid: "",
    empcode: "",
    ctype: "",
  });
  const [newUser, setNewUser] = useState({
    id: "",
    userid: "",
    password: "",
    empcode: "",
    active: "",
    type: "",
    versionapp: "",
    versionexp: "",
    apptoken: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_, newValue) => {
    setTabValue(newValue);
  };

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  useEffect(() => {
    fetchDivisions();
  }, []);

  useEffect(() => {
    const fetchEmpDetailsByCode = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${apiUrl}employee/byCode/${selectedId}`,
          { headers },
        );
        if (response.data.cd === 1) {
          toast.error(response.data.description);
          setLoading(false);
        } else {
          const { empContacts, employee, user } = response.data;
          setEmpcontact(empContacts || []);
          setNewItem({
            id: employee.id || "",
            empid: employee.empid || "",
            code: employee.code || "",
            name: employee.name || "",
            lastname: employee.lastname || "",
            gender: employee.gender || "",
            supervisor: parseFloat(employee.supervisor),
            department: parseFloat(employee.department),
            designation: employee.designation || "",
          });
          setNewodtItem({
            id: empContacts.id || "",
            addressline1: empContacts.addressline1 || "",
            addressline2: empContacts.addressline1 || "",
            pincode: empContacts.pincode || "",
            city: empContacts.city || "",
            dist: empContacts.dist || "",
            state: empContacts.state || "",
            country: empContacts.country || "",
            primaryphone: empContacts.primaryphone || "",
            secondaryphone: empContacts.primaryphone || "",
            emailid: empContacts.emailid || "",
            empcode: empContacts.empcode || "",
            ctype: empContacts.ctype || "",
          });
          setNewUser({
            id: user.id || "",
            userid: user.userid || "",
            password: user.password || "",
            empcode: user.empcode || "",
            active: user.active || "",
            type: user.type || "",
            versionapp: user.versionapp || "",
            versionexp: user.versionexp || "",
            apptoken: user.apptoken || "",
          });
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching employee details:", error);
        toast.error("Failed to fetch employee details.");
      } finally {
        setLoading(false);
      }
    };

    if (selectedId) {
      fetchEmpDetailsByCode();
    }
  }, [apiUrl, selectedId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}employee`, { headers });
        const employeeOptions = response.data.map((op) => ({
          value: op.code,
          label: op.name,
        }));
        setSupervisorOptions(employeeOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [apiUrl]);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  useEffect(() => {
    const fetchGenderOptions = () => {
      try {
        const response = getDropDownVal("GN");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setGenderOptions(actOption);
      } catch (error) {
        console.log("error");
      }
    };
    fetchGenderOptions();
  }, []);

  useEffect(() => {
    const fetchCtypeOptions = () => {
      try {
        const response = getDropDownVal("ADD");
        const actOption = response.map((op) => ({
          value: op.code,
          label: op.value,
        }));
        setCtypeOptions(actOption);
      } catch (error) {
        console.log("error");
      }
    };
    fetchCtypeOptions();
  }, []);

  function clearFields() {
    setNewItem({
      name: "",
      lastname: "",
      gender: "",
      empid: "",
      supervisor: "",
      department: "",
      designation: "",
    });
    setNewodtItem({
      addressline1: "",
      addressline2: "",
      pincode: "",
      city: "",
      dist: "",
      state: "",
      country: "",
      primaryphone: "",
      secondaryphone: "",
      emailid: "",
      ctype: "",
    });
    setNewUser({
      password: "",
      empcode: "",
    });
  }

  function clearFieldContact() {
    setNewodtItem({
      addressline1: "",
      addressline2: "",
      pincode: "",
      city: "",
      dist: "",
      state: "",
      country: "",
      primaryphone: "",
      secondaryphone: "",
      emailid: "",
      ctype: "",
    });
  }

  const validateFields = () => {
    let errors = {};
    const isValidPassword = (value) => /^(?=.*[@$!%*?&]).{8,}$/.test(value);
    if (!newItem.name.trim()) errors.name = "Name is required.";
    if (!newItem.gender) errors.gender = "Gender is required.";
    if (!newItem.empid) errors.empid = "Employee Id is required.";
    if (!newItem.department) errors.department = "Department is required.";
    if (!newItem.designation) errors.designation = "Designation is required.";
    if (newUser.password && !isValidPassword(newUser.password)) {
      errors.password = "Password must be at least 8 characters long..";
    }
    return errors;
  };

  const validateUpdateFields = () => {
    let errors = {};
    if (!newItem.name.trim()) errors.name = "Name is required.";
    if (!newItem.gender) errors.gender = "Gender is required.";
    if (!newItem.empid) errors.empid = "Employee Id is required.";
    if (!newItem.designation) errors.designation = "Designation is required.";
    if (!newItem.department) errors.department = "Department is required.";
    return errors;
  };

  const handlesubmit = async () => {
    setLoading(true);
    const fieldErrors = validateFields();
    setErrors(fieldErrors);
    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct the errors in the form.");
      setLoading(false);
      return;
    }
    if (empcontact.length == 0) {
      toast.error("Please add one contact details.");
      setLoading(false);
      return;
    }

    const emp = {
      name: newItem.name,
      lastname: newItem.lastname,
      gender: newItem.gender,
      empid: newItem.empid,
      supervisor: newItem.supervisor,
      department: newItem.department,
      designation: newItem.designation,
    };

    const empuser = newUser.password
      ? {
          userid: newItem.empid,
          password: newUser.password,
          active: 1,
          type: 2,
          seccode: 1,
          divcode: 1,
          versionapp: newUser.versionapp,
          versionexp: newUser.versionexp,
          apptoken: newUser.apptoken,
        }
      : null;

    const empRegistrationData = {
      employee: emp,
      empContacts: empcontact,
      user: empuser,
    };

    try {
      if (mode === "A") {
        await axios
          .post(apiUrl + "employee", empRegistrationData, { headers })
          .then((response) => {
            if (response.data.cd === 0) {
              setSucessMessage(response.data.description);
              setTitle("✔️Success");
              setShowSucessModal(true);
              setLoading(false);
            } else {
              setSucessMessage(response.data.description);
              setTitle("⚠️ Failed");
              setShowSucessModal(true);
              setLoading(false);
            }
          });
      }

      setNewItem({
        id: "",
        code: "",
        name: "",
        lastname: "",
        gender: "",
        empid: "",
        department: "",
        designation: "",
      });
      setNewodtItem({
        id: "",
        addressline1: "",
        addressline2: "",
        pincode: "",
        city: "",
        dist: "",
        state: "",
        country: "",
        primaryphone: "",
        secondaryphone: "",
        emailid: "",
        empcode: "",
        ctype: "",
      });
    } catch (error) {
      console.error("Error saving item:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateContact = async () => {
    setLoading(true);
    if (empcontact.length == 0) {
      toast.error("Please add one Contact details.");
      setLoading(false);
      return;
    }
    try {
      if (mode === "U") {
        await axios
          .put(apiUrl + "empcontact", empcontact, { headers })
          .then((response) => {
            if (response.data.cd === 1) {
              setSucessMessage(response.data.description);
              setTitle("⚠️ Failed");
              setShowSucessModal(true);
              setLoading(false);
            } else {
              setSucessMessage(response.data.description);
              setTitle("✔️Success");
              setShowSucessModal(true);
              setLoading(false);
            }
          });
      }
      setNewodtItem({
        id: "",
        addressline1: "",
        addressline2: "",
        pincode: "",
        city: "",
        dist: "",
        state: "",
        country: "",
        primaryphone: "",
        secondaryphone: "",
        emailid: "",
        empcode: newItem.code,
        ctype: "",
      });
    } catch (error) {
      console.error("Error saving item:", error);
    }
  };

  const validateContactFields = () => {
    let errors = {};
    const isNumeric = (value) => /^[0-9]{10}$/.test(value);
    const isSixDigitPincode = (value) => /^[0-9]{6}$/.test(value);
    const isValidEmail = (value) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(value);
    };
    if (!isNumeric(newodtItem.primaryphone)) {
      errors.primaryphone = "Phone Number must be exactly 10 digits..!";
    }
    if (newodtItem.secondaryphone && !isNumeric(newodtItem.secondaryphone)) {
      errors.secondaryphone = "Phone Number must be exactly 10 digits..!";
    }
    if (!newodtItem.addressline1.trim()) {
      errors.addressline1 = "Address 1 is required.";
    }
    if (!isSixDigitPincode(newodtItem.pincode)) {
      errors.pincode = "Pincode must be required";
    }
    if (!newodtItem.dist.trim()) {
      errors.dist = "District is required.";
    }
    if (!newodtItem.ctype) {
      errors.ctype = "Address Type is Required..!";
    }
    if (newodtItem.emailid && !isValidEmail(newodtItem.emailid)) {
      errors.emailid =
        "Invalid email format. Please enter a valid email address.";
    }
    return errors;
  };

  const fetchDivisions = async () => {
    setLoading(true);
    try {
      const response = await axios.get(apiUrl + "division", { headers });
      const divOptions = response.data.map((op) => ({
        value: op.code,
        label: op.name,
      }));
      setDivisionData(divOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddContact = () => {
    const fieldErrors = validateContactFields();
    setErrors(fieldErrors);
    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct the errors in the form.");
      return;
    }
    if (newodtItem.id) {
      const updatedContacts = empcontact.map((doc) =>
        doc.id === newodtItem.id ? newodtItem : doc,
      );
      setEmpcontact(updatedContacts);
    } else {
      setEmpcontact([...empcontact, { ...newodtItem, empcode: newItem.code }]);
    }
    setNewodtItem({
      id: "",
      addressline1: "",
      addressline2: "",
      pincode: "",
      city: "",
      dist: "",
      state: "",
      country: "",
      primaryphone: "",
      secondaryphone: "",
      emailid: "",
      empcode: newItem.code,
      ctype: "",
    });
  };

  const handleContactChange = async (field, value) => {
    setNewodtItem({ ...newodtItem, [field]: value });
    if (field === "pincode") {
      const enteredPincode = value.trim();
      setPincodeError("");
      if (enteredPincode.length !== 6 || isNaN(enteredPincode)) {
        setPincodeError("and Please enter a valid 6-digit pincode.");
        setLoadingc(true);
        return;
      }
      try {
        const response = await axios.get(
          `https://api.postalpincode.in/pincode/${enteredPincode}`,
        );
        if (
          response.data &&
          response.data.length > 0 &&
          response.data[0].Status === "Success"
        ) {
          const postOffice = response.data[0].PostOffice[0];
          setNewodtItem((prevState) => ({
            ...prevState,
            city: postOffice.Block,
            dist: postOffice.District,
            state: postOffice.State,
            country: postOffice.Country,
          }));
          setLoadingc(false);
        } else {
          setNewodtItem((prevState) => ({
            ...prevState,
            city: "",
            dist: "",
            state: "",
          }));
          setPincodeError("Pincode not found.");
          setLoadingc(true);
        }
      } catch (error) {
        setPincodeError(
          "Error fetching pincode details. Please try again later.",
        );
      }
    }
  };

  const handleEditContact = (doc) => {
    setNewodtItem({ ...doc });
  };

  const handleContactDelete = (index) => {
    confirmDelete(index).then((result) => {
      if (result.isConfirmed) {
        const newContacts = empcontact.filter((_, i) => i !== index);
        setEmpcontact(newContacts);
        showSuccessAlert();
      }
    });
  };

  const renderContactPreview = (doc, index) => {
    const getCtypeLabel = (ctypeValue) => {
      const option = ctypeOptions.find((opt) => opt.value === ctypeValue);
      return option ? option.label : ctypeValue;
    };

    return (
      <Box
        key={index}
        sx={{
          width: "100%",
          mb: 1.5,
          border: `1px solid ${BORDER}`,
          borderRadius: "10px",
          overflow: "hidden",
          backgroundColor: "#FFFFFF",
          boxShadow: "0 2px 8px rgba(18,59,93,0.06)",
        }}
      >
        <Box
          sx={{
            px: 1.5,
            py: 1,
            backgroundColor: "#F3F7FB",
            borderBottom: `1px solid ${BORDER}`,
          }}
        >
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 700,
              color: NAVY,
            }}
          >
            {doc.id ? `Contact Details ${index + 1}` : "This is Temporary Data"}
          </Typography>
        </Box>

        <Box
          sx={{
            px: 1.5,
            py: 1.25,
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr",
              },
              columnGap: 2,
              rowGap: 0.8,
            }}
          >
            <Typography sx={{ fontSize: 12 }}>
              <strong>Address Line 1:</strong> {doc.addressline1}
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              <strong>Address Line 2:</strong> {doc.addressline2}
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              <strong>Pincode:</strong> {doc.pincode}
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              <strong>City:</strong> {doc.city}
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              <strong>District:</strong> {doc.dist}
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              <strong>State:</strong> {doc.state}
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              <strong>Country:</strong> {doc.country}
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              <strong>Primary Phone:</strong> {doc.primaryphone}
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              <strong>Secondary Phone:</strong> {doc.secondaryphone}
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              <strong>Email ID:</strong> {doc.emailid}
            </Typography>
            <Typography sx={{ fontSize: 12 }}>
              <strong>Address Type:</strong> {getCtypeLabel(doc.ctype)}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 1,
              mt: 1.25,
              pt: 1,
              borderTop: `1px solid #EEF2F6`,
            }}
          >
            {doc.id && (
              <Button
                variant="outlined"
                size="small"
                startIcon={<EditOutlinedIcon />}
                onClick={() => handleEditContact(doc)}
                disabled={loading}
                sx={{
                  height: 32,
                  borderRadius: "7px",
                  textTransform: "none",
                  fontSize: 12,
                  fontWeight: 600,
                  color: NAVY,
                  borderColor: "#C9D5E0",
                  "&:hover": {
                    borderColor: NAVY,
                    backgroundColor: "#F4F8FB",
                  },
                }}
              >
                Edit
              </Button>
            )}
            <Button
              variant="outlined"
              size="small"
              startIcon={<DeleteOutlineRoundedIcon />}
              onClick={() => handleContactDelete(index)}
              disabled={loading}
              sx={{
                height: 32,
                borderRadius: "7px",
                textTransform: "none",
                fontSize: 12,
                fontWeight: 600,
                color: "#D64545",
                borderColor: "#E7BDBD",
                "&:hover": {
                  borderColor: "#D64545",
                  backgroundColor: "#FFF5F5",
                },
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Box>
    );
  };

  const renderTabs = (showAccess) => (
    <Tabs value={tabValue} onChange={handleTabChange} centered sx={tabStyles}>
      <Tab label="Basic Details" />
      {showAccess && <Tab label="Access" />}
      <Tab label="Contact Details" />
    </Tabs>
  );

  const renderBasicFields = () => (
    <Row>
      <Col md={6}>
        <div className="form-group">
          <label>First Name</label>
          <input
            type="text"
            placeholder="Enter Name"
            value={newItem.name}
            onChange={(e) => setNewItem({ ...newItem, name: e.target.value })}
            className="form-control"
          />
          {errors.name && <span className="error-message">{errors.name}</span>}
        </div>
      </Col>

      <Col md={6}>
        <div className="form-group">
          <label>Last Name</label>
          <input
            type="text"
            placeholder="Enter Last Name"
            value={newItem.lastname}
            onChange={(e) =>
              setNewItem({
                ...newItem,
                lastname: e.target.value,
              })
            }
            className="form-control"
          />
        </div>
      </Col>

      <Col md={6}>
        <div className="form-group">
          <label>Gender</label>
          <Select
            isClearable
            name="type"
            options={genderOptions}
            placeholder="Enter Gender"
            value={genderOptions.find(
              (option) => option.value === newItem.gender,
            )}
            onChange={(selectedOption) =>
              setNewItem({
                ...newItem,
                gender: selectedOption ? selectedOption.value : "",
              })
            }
            menuPortalTarget={document.body}
            menuPosition="fixed"
            classNamePrefix="select"
          />
          {errors.gender && (
            <span className="error-message">{errors.gender}</span>
          )}
        </div>
      </Col>

      <Col md={6}>
        <div className="form-group">
          <label>Supervisor</label>
          <Select
            isClearable
            options={supervisorOptions}
            placeholder="Select Supervisor"
            value={supervisorOptions.find(
              (option) => option.value === newItem.supervisor,
            )}
            onChange={(selectedOption) =>
              setNewItem({
                ...newItem,
                supervisor: selectedOption ? selectedOption.value : "",
              })
            }
            menuPortalTarget={document.body}
            menuPosition="fixed"
            classNamePrefix="select"
          />
        </div>
      </Col>

      <Col md={6}>
        <div className="form-group">
          <label>Department</label>
          <Select
            isClearable
            options={divisionData}
            placeholder="Select Department"
            value={divisionData.find(
              (option) => option.value === newItem.department,
            )}
            onChange={(selectedOption) =>
              setNewItem({
                ...newItem,
                department: selectedOption ? selectedOption.value : "",
              })
            }
            menuPortalTarget={document.body}
            menuPosition="fixed"
            classNamePrefix="select"
          />
          {errors.department && (
            <span className="error-message">{errors.department}</span>
          )}
        </div>
      </Col>

      <Col md={6}>
        <div className="form-group">
          <label>Designation</label>
          <input
            type="text"
            placeholder="Enter Designation"
            value={newItem.designation}
            onChange={(e) =>
              setNewItem({
                ...newItem,
                designation: e.target.value,
              })
            }
            className="form-control"
          />
          {errors.designation && (
            <span className="error-message">{errors.designation}</span>
          )}
        </div>
      </Col>
    </Row>
  );

  const renderAccessFields = () => (
    <Row>
      <Col md={6}>
        <div className="form-group">
          <label>Employee Id/Login Id</label>
          <input
            type="text"
            placeholder="Enter Employee Id/Login Id"
            value={newItem.empid}
            onChange={(e) =>
              setNewItem({
                ...newItem,
                empid: e.target.value,
              })
            }
            className="form-control"
          />
          {errors.empid && (
            <span className="error-message">{errors.empid}</span>
          )}
        </div>
      </Col>

      <Col md={6}>
        <div className="form-group">
          <label>Password</label>
          <Box sx={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter Password"
              required
              value={newUser.password}
              onChange={(e) =>
                setNewUser({
                  ...newUser,
                  password: e.target.value,
                })
              }
              className="form-control"
              style={{
                paddingRight: "2.75rem",
              }}
            />
            <IconButton
              onClick={togglePasswordVisibility}
              aria-label={showPassword ? "Hide password" : "Show password"}
              size="small"
              sx={{
                position: "absolute",
                right: 6,
                top: "50%",
                transform: "translateY(-50%)",
                color: "#6C7A88",
              }}
            >
              {showPassword ? (
                <VisibilityOffOutlinedIcon sx={{ fontSize: 19 }} />
              ) : (
                <VisibilityOutlinedIcon sx={{ fontSize: 19 }} />
              )}
            </IconButton>
          </Box>
          {errors.password && (
            <span className="error-message">{errors.password}</span>
          )}
        </div>
      </Col>
    </Row>
  );

  const renderContactFields = (isUpdateMode) => (
    <>
      {empcontact.map((doc, index) =>
        index % 2 === 0 ? (
          <Box
            key={index}
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "1fr 1fr",
              },
              gap: 1.5,
              mb: 1.5,
            }}
          >
            {renderContactPreview(doc, index)}
            {empcontact.length > index + 1 &&
              renderContactPreview(empcontact[index + 1], index + 1)}
          </Box>
        ) : null,
      )}

      <Row>
        <Col md={4}>
          <div className="form-group">
            <label>Pincode</label>
            <input
              type="number"
              min="0"
              placeholder="Enter Pincode"
              value={newodtItem.pincode}
              onChange={(e) => handleContactChange("pincode", e.target.value)}
              className="form-control"
            />
            {errors.pincode && (
              <span className="error-message">{errors.pincode}</span>
            )}
            {pincodeError && (
              <span className="error-message">{pincodeError}</span>
            )}
          </div>
        </Col>

        <Col md={4}>
          <div className="form-group">
            <label>Address Line 1</label>
            <input
              type="text"
              placeholder="Enter Address Line 1"
              value={newodtItem.addressline1}
              onChange={(e) =>
                handleContactChange("addressline1", e.target.value)
              }
              className="form-control"
            />
            {errors.addressline1 && (
              <span className="error-message">{errors.addressline1}</span>
            )}
          </div>
        </Col>

        <Col md={4}>
          <div className="form-group">
            <label>Address Line 2</label>
            <input
              type="text"
              placeholder="Enter Address Line 2"
              value={newodtItem.addressline2}
              onChange={(e) =>
                handleContactChange("addressline2", e.target.value)
              }
              className="form-control"
            />
          </div>
        </Col>

        <Col md={4}>
          <div className="form-group">
            <label>City</label>
            <input
              disabled
              type="text"
              placeholder="Enter City"
              value={newodtItem.city}
              onChange={(e) => handleContactChange("city", e.target.value)}
              className="form-control"
            />
          </div>
        </Col>

        <Col md={4}>
          <div className="form-group">
            <label>District</label>
            <input
              disabled
              type="text"
              placeholder="Enter District"
              value={newodtItem.dist}
              onChange={(e) => handleContactChange("dist", e.target.value)}
              className="form-control"
            />
            {errors.dist && (
              <span className="error-message">{errors.dist}</span>
            )}
          </div>
        </Col>

        <Col md={4}>
          <div className="form-group">
            <label>State</label>
            <input
              disabled
              type="text"
              placeholder="Enter State"
              value={newodtItem.state}
              onChange={(e) => handleContactChange("state", e.target.value)}
              className="form-control"
            />
          </div>
        </Col>

        <Col md={4}>
          <div className="form-group">
            <label>Country</label>
            <input
              disabled
              type="text"
              placeholder="Enter Country"
              value={newodtItem.country}
              onChange={(e) => handleContactChange("country", e.target.value)}
              className="form-control"
            />
          </div>
        </Col>

        <Col md={4}>
          <div className="form-group">
            <label>Primary Phone</label>
            <input
              type="number"
              min="0"
              placeholder="Enter Phone Number"
              value={newodtItem.primaryphone}
              onChange={(e) =>
                handleContactChange("primaryphone", e.target.value)
              }
              className="form-control"
            />
            {errors.primaryphone && (
              <span className="error-message">{errors.primaryphone}</span>
            )}
          </div>
        </Col>

        <Col md={4}>
          <div className="form-group">
            <label>Secondary Phone</label>
            <input
              type="number"
              min="0"
              placeholder="Enter Phone Number"
              value={newodtItem.secondaryphone}
              onChange={(e) =>
                handleContactChange("secondaryphone", e.target.value)
              }
              className="form-control"
            />
            {errors.secondaryphone && (
              <span className="error-message">{errors.secondaryphone}</span>
            )}
          </div>
        </Col>

        <Col md={4}>
          <div className="form-group">
            <label>Email Id</label>
            <input
              type="text"
              placeholder="Enter Email Id"
              value={newodtItem.emailid}
              onChange={(e) => handleContactChange("emailid", e.target.value)}
              className="form-control"
            />
            {errors.emailid && (
              <span className="error-message">{errors.emailid}</span>
            )}
          </div>
        </Col>

        <Col md={4}>
          <div className="form-group">
            <label>Address Type</label>
            <Select
              isClearable
              name="type"
              options={ctypeOptions}
              placeholder="Enter Address Type"
              value={
                newodtItem.ctype
                  ? ctypeOptions.find(
                      (option) => option.value === newodtItem.ctype,
                    )
                  : null
              }
              onChange={(selectedOption) =>
                handleContactChange(
                  "ctype",
                  selectedOption ? selectedOption.value : "",
                )
              }
              menuPortalTarget={document.body}
              menuPosition="fixed"
              classNamePrefix="select"
            />
            {errors.ctype && (
              <span className="error-message">{errors.ctype}</span>
            )}
          </div>
        </Col>
      </Row>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 0.5,
        }}
      >
        <Button
          variant="contained"
          onClick={handleAddContact}
          disabled={loading || loadingc}
          sx={{
            minWidth: 150,
            height: 38,
            borderRadius: "8px",
            textTransform: "none",
            fontSize: 13,
            fontWeight: 600,
            backgroundColor: NAVY,
            "&:hover": {
              backgroundColor: "#0E2F4A",
            },
          }}
        >
          {newodtItem.id ? "Update Contact" : "Add Contact"}
        </Button>
      </Box>
    </>
  );

  if (mode === "A") {
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />

        <div className="popupmodal-maindiv">
          {renderTabs(true)}

          {tabValue === 0 && <Box sx={{ pt: 1.5 }}>{renderBasicFields()}</Box>}

          {tabValue === 1 && <Box sx={{ pt: 1.5 }}>{renderAccessFields()}</Box>}

          {tabValue === 2 && (
            <Box sx={{ pt: 1.5 }}>{renderContactFields(false)}</Box>
          )}

          <div className="bottombtn">
            <button
              className="btn btn-success"
              disabled={loading}
              onClick={handlesubmit}
            >
              Save
            </button>
            <button className="btn btn-danger" onClick={clearFields}>
              Reset
            </button>
          </div>

          {loading && <CustomLoader />}
        </div>
      </>
    );
  }

  if (mode === "U") {
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />

        <div className="popupmodal-maindiv">
          {renderTabs(false)}

          {tabValue === 0 && (
            <Box sx={{ pt: 1.5 }}>
              <Row>
                <Col md={6}>
                  <div className="form-group">
                    <label>Code</label>
                    <input
                      disabled
                      placeholder="Enter Code"
                      value={newItem.code}
                      onChange={(e) =>
                        setNewItem({
                          ...newItem,
                          code: e.target.value,
                        })
                      }
                      className="form-control"
                    />
                    {errors.code && (
                      <span className="error-message">{errors.code}</span>
                    )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label>Password</label>
                    <Box sx={{ position: "relative" }}>
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter Password"
                        required
                        value={newUser.password}
                        onChange={(e) =>
                          setNewUser({
                            ...newUser,
                            password: e.target.value,
                          })
                        }
                        className="form-control"
                        style={{
                          paddingRight: "2.75rem",
                        }}
                      />
                      <IconButton
                        onClick={togglePasswordVisibility}
                        aria-label={
                          showPassword ? "Hide password" : "Show password"
                        }
                        size="small"
                        sx={{
                          position: "absolute",
                          right: 6,
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#6C7A88",
                        }}
                      >
                        {showPassword ? (
                          <VisibilityOffOutlinedIcon sx={{ fontSize: 19 }} />
                        ) : (
                          <VisibilityOutlinedIcon sx={{ fontSize: 19 }} />
                        )}
                      </IconButton>
                    </Box>
                    {errors.password && (
                      <span className="error-message">{errors.password}</span>
                    )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label>First Name</label>
                    <input
                      type="text"
                      placeholder="Enter Name"
                      value={newItem.name}
                      onChange={(e) =>
                        setNewItem({
                          ...newItem,
                          name: e.target.value,
                        })
                      }
                      className="form-control"
                    />
                    {errors.name && (
                      <span className="error-message">{errors.name}</span>
                    )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label>Last Name</label>
                    <input
                      type="text"
                      placeholder="Enter Last Name"
                      value={newItem.lastname}
                      onChange={(e) =>
                        setNewItem({
                          ...newItem,
                          lastname: e.target.value,
                        })
                      }
                      className="form-control"
                    />
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label>Gender</label>
                    <Select
                      isClearable
                      name="type"
                      options={genderOptions}
                      placeholder="Enter Gender"
                      value={genderOptions.find(
                        (option) => option.value === newItem.gender,
                      )}
                      onChange={(selectedOption) =>
                        setNewItem({
                          ...newItem,
                          gender: selectedOption ? selectedOption.value : "",
                        })
                      }
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      classNamePrefix="select"
                    />
                    {errors.gender && (
                      <span className="error-message">{errors.gender}</span>
                    )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label>Supervisor</label>
                    <Select
                      isClearable
                      options={supervisorOptions}
                      placeholder="Select Supervisor"
                      value={supervisorOptions.find(
                        (option) => option.value === newItem.supervisor,
                      )}
                      onChange={(selectedOption) =>
                        setNewItem({
                          ...newItem,
                          supervisor: selectedOption
                            ? selectedOption.value
                            : "",
                        })
                      }
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      classNamePrefix="select"
                    />
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label>Department</label>
                    <Select
                      isClearable
                      options={divisionData}
                      placeholder="Select Department"
                      value={divisionData.find(
                        (option) => option.value === newItem.department,
                      )}
                      onChange={(selectedOption) =>
                        setNewItem({
                          ...newItem,
                          department: selectedOption
                            ? selectedOption.value
                            : "",
                        })
                      }
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      classNamePrefix="select"
                    />
                    {errors.department && (
                      <span className="error-message">{errors.department}</span>
                    )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="form-group">
                    <label>Designation</label>
                    <input
                      type="text"
                      placeholder="Enter Designation"
                      value={newItem.designation}
                      onChange={(e) =>
                        setNewItem({
                          ...newItem,
                          designation: e.target.value,
                        })
                      }
                      className="form-control"
                    />
                    {errors.designation && (
                      <span className="error-message">
                        {errors.designation}
                      </span>
                    )}
                  </div>
                </Col>
              </Row>
            </Box>
          )}

          {tabValue === 1 && (
            <Box sx={{ pt: 1.5 }}>{renderContactFields(true)}</Box>
          )}

          <div className="bottombtn">
            <button
              className="btn btn-success"
              onClick={handleUpdateContact}
              disabled={loading}
            >
              Update
            </button>
            <button
              className="btn btn-danger"
              onClick={clearFieldContact}
              disabled={loading}
            >
              Reset
            </button>
          </div>

          {loading && <CustomLoader />}
        </div>
      </>
    );
  }

  return null;
};

export default SampEmp;
